module.exports = __webpack_public_path__ + "img/Johnston_Twisp_4227.e09511a8.jpg";